var exports = {
  "button": "MediaPlaybackRate.module__button___LWZGcm",
  "small": "MediaPlaybackRate.module__small___LWZGcm",
  "medium": "MediaPlaybackRate.module__medium___LWZGcm",
  "large": "MediaPlaybackRate.module__large___LWZGcm",
  "active": "MediaPlaybackRate.module__active___LWZGcm",
  "label": "MediaPlaybackRate.module__label___LWZGcm",
};

__webpack_require__.r(module.exports = exports);
